<template>
  <dl class="metric-strip">
    <div v-for="item in items" :key="item.label" class="metric-strip__item">
      <dt>{{ item.label }}</dt>
      <dd>{{ item.value }}</dd>
      <dd v-if="item.detail" class="metric-strip__detail">{{ item.detail }}</dd>
    </div>
  </dl>
</template>

<script setup>
defineProps({
  items: {
    type: Array,
    default: () => [],
  },
})
</script>

<style scoped>
.metric-strip {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(9rem, 1fr));
  margin: 0;
  border: 1px solid var(--border);
  border-radius: var(--radius-surface);
  background: var(--surface);
}

.metric-strip__item {
  min-width: 0;
  padding: var(--space-3) var(--space-4);
}

.metric-strip__item + .metric-strip__item {
  border-left: 1px solid var(--border);
}

dt,
.metric-strip__detail {
  color: var(--ink-muted);
  font-size: 0.75rem;
  font-weight: 600;
  letter-spacing: 0.03em;
  line-height: 1.35;
  text-transform: uppercase;
}

dt,
dd {
  margin: 0;
}

dd {
  margin-top: var(--space-1);
  font-family: var(--font-academic);
  font-size: 1.75rem;
  line-height: 1.15;
}

.metric-strip__detail {
  margin-top: var(--space-1);
  font-size: 0.6875rem;
  letter-spacing: 0;
  text-transform: none;
}

@media (max-width: 767px) {
  .metric-strip {
    grid-template-columns: minmax(0, 1fr);
  }

  .metric-strip__item + .metric-strip__item {
    border-top: 1px solid var(--border);
    border-left: 0;
  }
}
</style>
